import api from "./Api";

class EspecieService {
  GetEspecie(payload) {
    return api.get("/v1/especie/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEspecie(payload) {
    return api.post("/v1/especie/", payload).then((response) => {
      return response.data;
    });
  }

  PutEspecie(payload) {
    return api.put("/v1/especie/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEspecie(payload) {
    return api.delete("/v1/especie/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEspecieOData(payload) {
    return api.get("/OData/Especie" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new EspecieService();
